import { render, staticRenderFns } from "./ModalBottom.vue?vue&type=template&id=c0732606&scoped=true"
import script from "./ModalBottom.vue?vue&type=script&lang=js"
export * from "./ModalBottom.vue?vue&type=script&lang=js"
import style0 from "./ModalBottom.vue?vue&type=style&index=0&id=c0732606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0732606",
  null
  
)

export default component.exports